module.exports = __webpack_public_path__ + "img/图片3-1.e35eef45.png";